export default __webpack_public_path__ + "static/media/AlternativeInv.2abf7b25.svg";